/*
 *  Mapping of IMS locale codes to supported app language.
 *  See https://git.corp.adobe.com/intl/adobe-locales under "IMS" for all
 *  supported IMS locales.
*/
export const supportedLocales = {
  en: 'en_US',
  br: 'pt_BR',
  cn: 'zh_CN',
  fr: 'fr_FR',
  de: 'de_DE',
  it: 'it_IT',
  jp: 'ja_JP',
  kr: 'ko_KR',
  es: 'es_ES',
  la: 'es_LA',
};

/* Friendly language mapping.
 * Used on the language selector component.
 * When adding a new language, make sure to include it here.
 */
export const friendlyLanguageName = {
  en_US: 'US - English',
  pt_BR: 'Brazil - Português',
  zh_CN: 'China - 简体中文',
  fr_FR: 'France - Français',
  de_DE: 'Germany - Deutsch',
  it_IT: 'Italy - Italiano',
  ja_JP: 'Japan – 日本語',
  ko_KR: 'Korea - 한국어',
  es_ES: 'Spain - Español',
  es_LA: 'Latin America - Español',
};

/** Salesforce Language Mapping
 * Used for direct registration links to Salesforce.
 */
export const sfLangMapping = {
  en_US: 'en_US',
  pt_BR: 'pt_BR',
  zh_CN: 'zh_CN',
  fr_FR: 'fr',
  de_DE: 'de',
  it_IT: 'it',
  ja_JP: 'ja',
  ko_KR: 'ko',
  es_ES: 'es',
  es_LA: 'es',
};

/* Preferred language mapping.
 * Used when user selects preferred language.
 * When adding a new language, make sure to include it here.
 */
export const preferredLanguageName = {
  'English': 'en_US',
  'Português': 'pt_BR',
  'Chinese': 'zh_CN',
  'French': 'fr_FR',
  'German': 'de_DE',
  'Italian': 'it_IT',
  'Japanese': 'ja_JP',
  'Korean': 'ko_KR',
  'Spanish': 'es_ES',
  'Latin America - Español': 'es_LA',
};

export const fallbackLocale = 'en_US';
